import React, { Component } from 'react'
import "../styles/mystyles.scss"
import { StaticImage } from "gatsby-plugin-image"

export default class Footer extends Component
{
  render()
  {
    return (
      <>
        <footer class="footer" style={{ backgroundColor: '#181818' }}>

          <div class="container is-max-desktop" style={{ alignContent: "center" }}>
            <div class="columns is-vcentered">
              <figure class="column is-one-third mt-6 has-text-centered " >
                <StaticImage
                  src="../images/Logo.png"
                  width={200}
                  quality={100}
                  imgStyle={{ paddingTop: "10px" }}
                  style={{ paddingTop: "10px" }}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="Dutch Tyres"
                />
              </figure>
              <div class="column has-text-white has-text-centered is-one-third mt-6 ">
                KVK: 52798143
              </div>
              <div class="column has-text-white is-one-third mt-6 has-text-centered pt-4">
                <StaticImage
                  src="../images/DPD_logo.png"
                  width={120}
                  quality={100}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="Brand logo"
                />
              </div>
            </div>
          </div>
        </footer >
      </>
    )
  }

}

